import { Helmet } from "react-helmet-async";
import config from "../config/stateConfig";

const UPDATED = "August 2026";

export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-16" data-testid="privacy-page">
      <Helmet>
        <title>{`Privacy Policy | ${config.brand}`}</title>
        <meta name="description" content={`How ${config.brand} collects, uses, and protects the information you provide when requesting a free case review.`} />
        <link rel="canonical" href={`https://${config.domain}/privacy`} />
      </Helmet>

      <h1 className="text-4xl sm:text-5xl font-bold text-navy mb-3">Privacy Policy</h1>
      <p className="text-sm text-navy/50 mb-10">Last updated: {UPDATED}</p>

      <div className="prose prose-neutral max-w-none space-y-6 text-navy/80 leading-relaxed">
        <p>
          {config.brand} ("we," "us") operates {config.domain}, a free service that connects
          people injured in {config.stateName} accidents with independent attorneys. We are not a
          law firm and do not provide legal advice. This policy explains what information we collect
          through this website and how we use it. It is an operational summary and may be updated.
        </p>

        <h2 className="text-2xl font-semibold text-navy">Information you provide</h2>
        <p>When you submit our case-review / contact form, you may provide: your name, phone number,
          email address, the type and date of your accident, your city, a description of your injuries
          and situation, and whether you already have an attorney. You are not required to submit any
          information you are not comfortable sharing.</p>

        <h2 className="text-2xl font-semibold text-navy">Information collected automatically</h2>
        <p>Like most websites, standard technical data (such as pages viewed and general device/browser
          information) may be collected. If website analytics are enabled, aggregate, non-identifying
          usage data may be used to understand and improve site performance.</p>

        <h2 className="text-2xl font-semibold text-navy">How we use your information</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>To respond to your request and, where appropriate, connect you with one or more
            independent attorneys for a free, no-obligation consultation.</li>
          <li>To communicate with you about your inquiry.</li>
          <li>To operate, maintain, and improve the website.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-navy">How your information is shared</h2>
        <p>Information you submit through the case-review form may be shared with independent attorneys
          in order to evaluate and respond to your request. We do not sell your personal information.
          We may disclose information if required by law.</p>

        <h2 className="text-2xl font-semibold text-navy">No attorney–client relationship</h2>
        <p>Submitting information through this website does not create an attorney–client relationship.
          Any such relationship is formed only by a separate written agreement with an attorney.</p>

        <h2 className="text-2xl font-semibold text-navy">Your choices</h2>
        <p>You may choose not to provide information, though this may limit our ability to assist you.
          To request that we update or delete information you submitted, contact us using the details
          below.</p>

        <h2 className="text-2xl font-semibold text-navy">Contact</h2>
        <p>Questions about this policy can be directed to us through our{" "}
          <a href="/contact" className="text-terracotta font-semibold hover:underline">contact page</a>{" "}
          or by phone at{" "}
          <a href={`tel:${config.phoneTel}`} className="text-terracotta font-semibold hover:underline">{config.phone}</a>.
        </p>
      </div>
    </div>
  );
}
